@if (
  {
    payment: paymentListener?.data$ | async,
    paymentLoadingError: paymentListener?.errorLoading$,
    isDownloadingInvoice: isDownloadingInvoice(),
    transactionStatus: transactionStatus()
  };
  as STATE
) {
  @if (STATE.payment) {
    <main class="stickers-payment-details">
      <section class="stickers-payment-details__header">
        <div class="stickers-payment-details__icon">
          @if (STATE.transactionStatus === 'completed') {
            <img
              [ngSrc]="'/assets/icons/success.png'"
              [width]="100"
              [height]="100"
              alt="Success icon"
            />
          }

          @if (STATE.transactionStatus === 'failed') {
            <img
              [ngSrc]="'/assets/icons/failed.png'"
              [width]="100"
              [height]="100"
              alt="Error icon"
            />
          }

          @if (STATE.transactionStatus === 'canceled') {
            <img
              [ngSrc]="'/assets/icons/deadline.png'"
              [width]="100"
              [height]="100"
              alt="Deadline icon"
            />
          }
        </div>
        <p class="stickers-payment-details__subtitle">
          @if (STATE.transactionStatus === 'completed') {
            <div
              class="stickers-payment-details__subtitle stickers-payment-details__subtitle-success"
            >
              Votre paiement a été validé et votre solde stickers a été crédité
              avec succès
            </div>
          }

          @if (STATE.transactionStatus === 'failed') {
            <div
              class="stickers-payment-details__subtitle stickers-payment-details__subtitle-error"
            >
              Echec de la transaction
            </div>
          }

          @if (STATE.transactionStatus === 'canceled') {
            <div
              class="stickers-payment-details__subtitle stickers-payment-details__subtitle-canceled"
            >
              Délai de confirmation dépassé
            </div>
          }
        </p>
      </section>

      <p class="stickers-payment-details__description">
        @if (STATE.transactionStatus === 'completed') {
          <div class="stickers-payment-details__description-success">
            Votre transaction s'est déroulée sans incident. Le solde de vos
            stickers a été mis à jour et vous pouvez désormais émettre vos
            factures électroniques en toute conformité.
          </div>
        }

        @if (STATE.transactionStatus === 'failed') {
          <div class="stickers-payment-details__description-error">
            Votre paiement n'a pas pu être validé. Aucun débit n'a été effectué.
            Nous vous invitons à réessayer la transaction ou à utiliser une
            autre methode de paiement si le problème persiste.
          </div>
        }

        @if (STATE.transactionStatus === 'canceled') {
          <div class="stickers-payment-details__description-canceled">
            La confirmation du paiement n’a pas été reçue à temps.
            <strong
              >Si vous avez validé le paiement, celui-ci sera pris en compte
              sous peu.</strong
            >
            Dans le cas contraire, merci de contacter les services de la FNE
            pour obtenir une assistance.
          </div>
        }
      </p>

      <section class="stickers-payment-details__details">
        <div class="stickers-payment-details__detail-row">
          <span class="stickers-payment-details__label">Montant</span>
          <span class="stickers-payment-details__value"
            >{{ STATE.payment.amount | money }}
          </span>
        </div>
        <div class="stickers-payment-details__detail-row">
          <span class="stickers-payment-details__label"
            >Référence de paiement</span
          >
          @if (STATE.payment.referenceTransaction; as referenceTransaction) {
            <span
              class="stickers-payment-details__value stickers-payment-details__value--id"
              >{{ referenceTransaction }}
              <div
                class="stickers-payment-details__value--id__copy"
                (click)="copyTransactionId(referenceTransaction)"
              >
                <mat-icon svgIcon="dgi-copy"></mat-icon>
              </div>
            </span>
          } @else {
            <span class="stickers-payment-details__value"> - </span>
          }
        </div>
        <div class="stickers-payment-details__detail-row">
          <span class="stickers-payment-details__label"
            >Méthode de paiement</span
          >
          <span class="stickers-payment-details__value">
            {{ $any(STATE.payment.paymentMethod) | paymentMethod }}</span
          >
        </div>
        <div class="stickers-payment-details__detail-row">
          <span class="stickers-payment-details__label"
            >Numero de téléphone</span
          >
          <span class="stickers-payment-details__value">
            {{ STATE.payment.phoneNumber }}</span
          >
        </div>
        <div class="stickers-payment-details__detail-row">
          <span class="stickers-payment-details__label"
            >Date de la transaction</span
          >
          <span class="stickers-payment-details__value">
            {{ STATE.payment.processedAt | dateTimeFormat }}
          </span>
        </div>
        @if (transactionStatus(); as status) {
          <div class="stickers-payment-details__detail-row">
            <span class="stickers-payment-details__label"
              >Statut de la transaction</span
            >
            <span class="stickers-payment-details__value">
              {{ status | transactionStatus }}
            </span>
          </div>
        }
      </section>

      <section class="stickers-payment-details__actions">
        <button
          (click)="redirectRoute()"
          class="stickers-payment-details__action-button stickers-payment-details__action-button--primary"
          [size]="'md'"
          [variant]="'primaryLight'"
          button
        >
          Retour au compte sticker
        </button>

        @if (STATE.transactionStatus === 'completed') {
          <button
            (click)="downloadInvoice(STATE.payment.id)"
            [disabled]="
              STATE.isDownloadingInvoice ||
              STATE.payment.result.status !== 'completed'
            "
            [size]="'md'"
            [variant]="'outline'"
            button
          >
            Télécharger le reçu (PDF)
          </button>
        }
      </section>
    </main>
  } @else {
    <main class="stickers-payment-details">
      <loading-or-error
        (retry)="loadPayment()"
        [error$]="STATE.paymentLoadingError"
        spinnerSize="sm"
      ></loading-or-error>
    </main>
  }
}
